module.exports = __webpack_public_path__ + "img/dch1.d2252618.jpg";